import React, { useEffect, useState } from "react";
import api from "../../lib/api";

const KIND_LABEL = {
  welcome: "Welcome",
  unlock_nudge: "25% Unlock Nudge",
  abandoned_checkout: "Abandoned Checkout",
  certificate: "Certificate Delivery",
};

export default function EmailsTab() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/marketing/emails").then((r) => setRows(r.data));
  }, []);

  return (
    <div data-testid="emails-tab" className="border border-slate-200 rounded-sm overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-[0.2em] font-bold text-slate-500">
          <tr>
            <th className="text-left p-3">Sent</th>
            <th className="text-left p-3">Type</th>
            <th className="text-left p-3">Recipient</th>
            <th className="text-left p-3">Subject</th>
            <th className="text-left p-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={5} className="p-6 text-slate-500" data-testid="emails-empty">No emails sent yet.</td></tr>}
          {rows.map((r, i) => (
            <tr key={i} className="border-t border-slate-200" data-testid={`email-row-${i}`}>
              <td className="p-3 text-slate-700 whitespace-nowrap">{r.created_at?.slice(0, 16).replace("T", " ")}</td>
              <td className="p-3 font-semibold text-slate-900">{KIND_LABEL[r.kind] || r.kind}</td>
              <td className="p-3 text-slate-700">{r.to}</td>
              <td className="p-3 text-slate-700">{r.subject}</td>
              <td className="p-3">
                <span className={`px-2 py-0.5 text-xs font-bold uppercase tracking-[0.15em] rounded-sm ${r.status === "sent" ? "bg-green-600 text-white" : "bg-red-600 text-white"}`} title={r.error || ""}>{r.status}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
